import React from 'react';
import Label from 'src/components/Label';
import { FlexBox } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

const DonorLabels = ({ donor, style }) => {
	const hasAssignments = donor.recent_assignments && donor.recent_assignments.length > 0;
	return (
		<FlexBox flexWrap="wrap" {...style}>
			{donor.deceased ? (
				<Label
					labelStyle={{
						color: theme.colors.white,
						backgroundColor: theme.colors['shade-grey'],
					}}
				>
					Deceased
				</Label>
			) : null}
			{hasAssignments ? (
				<Label
					labelStyle={{
						color: theme.colors.white,
						backgroundColor: theme.colors['steel-blue'],
					}}
				>
					Newly Assigned to {donor.recent_assignments[0].fundraiserName}
				</Label>
			) : null}
			{donor.top_prospect ? (
				<Label
					labelStyle={{
						color: theme.colors.white,
						backgroundColor: theme.colors.slateBlue,
					}}
				>
					Top Prospect
				</Label>
			) : null}
			{donor.high_confidence ? (
				<Label
					labelStyle={{
						color: theme.colors.white,
						backgroundColor: theme.colors['shiny-shamrock'],
					}}
				>
					High Confidence
				</Label>
			) : null}
			{donor.at_risk ? (
				<Label
					labelStyle={{
						color: theme.colors.white,
						backgroundColor: theme.colors.pastelRed,
					}}
				>
					At Risk
				</Label>
			) : null}
			{donor.giving_streak_monthly && donor.giving_streak_monthly > 2 ? (
				<Label
					labelStyle={{
						color: theme.colors.white,
						backgroundColor: theme.colors['royal-orange'],
					}}
				>
					Monthly Donor
				</Label>
			) : null}
		</FlexBox>
	);
};

export default DonorLabels;



// WEBPACK FOOTER //
// ./src/components/DonorLabels/index.js